import { render, staticRenderFns } from "./VNTrip.vue?vue&type=template&id=925bd512&"
import script from "./VNTrip.vue?vue&type=script&lang=js&"
export * from "./VNTrip.vue?vue&type=script&lang=js&"
import style0 from "./VNTrip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports